module.exports = __webpack_public_path__ + "media/limitations/estorbos-2d7d204f.png";